<template>
  <div class="cloud-intercom-page">
    <div class="ci-body ci-body--center">
      <div class="ci-status-icon">
        <img src="@/assets/img/intercom/warning-location@3x.webp" />
      </div>
      <h2 class="ci-body__heading">
        {{ $t('Intercom.CloudIntercom.OutOfRangePage.Heading') }}
      </h2>
      <p class="ci-body__message">
        {{ $t('Intercom.CloudIntercom.OutOfRangePage.Message') }}
      </p>
      <div class="ci-info-block">
        <p class="ci-info-block__title-wrap">
          <img src="@/assets/img/intercom/info@3x.webp" />
          <span class="ci-info-block__title-text">{{ $t('Intercom.CloudIntercom.OutOfRangePage.HowToTitle') }}</span>
        </p>
        <p class="ci-info-block__desc">
          {{ $t('Intercom.CloudIntercom.OutOfRangePage.HowToDesc') }}
        </p>
      </div>
    </div>
    <div class="ci-footer">
      <button
        class="ci-btn ci-btn--primary"
        @click="$emit('retry-location')"
      >
        {{ $t('Intercom.CloudIntercom.OutOfRangePage.Arrived') }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OutOfRangePage'
}
</script>

<style lang="scss" scoped>
@import './cloudIntercom';

.ci-body {
  padding-top: 56px;
}

.ci-footer {
  margin-top: 8px;
}
</style>
